module.exports = __webpack_public_path__ + "img/mind_skeleton_2.a427c3ee.png";